<template>
  <div ref="download" class="download">
    <div class="download__background"></div>
    <div class="download__right animated fadeInRight">
      <div class="download__content">
        <p class="download__content__title">
          受益一生的能力
        </p>
        <p class="download__content__client">
          电脑客户端
        </p>
        <template v-if="operatingSystem === 'Mac'">
          <p class="download__content__alert">{{ alert2 }}</p>
          <a
            v-if="(n1 === 10 && n2 > 11) || n1 > 10"
            :data-xeslog-params="
              `key=xeslog-pcdown-www&action=click-pcbtn-pcdown&os=${operatingSystem}&oslev=${n1}.${n2}`
            "
            class="download__content__btn"
            href="javascript: () => {return false}"
            @click="handleDownload(true)"
          >
          </a>
          <!-- <a
            v-if="n1 === 10 && n2 > 9"
            class="download__content__btn"
            :href="
              `https://liveclient.xesimg.com/${macRootPath}/xes_live_mac_v${macVersion}.dmg?time=${dateTime}&filename=.dmg`
            "
            :data-xeslog-params="
              `key=xeslog-pcdown-www&action=click-pcbtn-pcdown&os=${operatingSystem}&oslev=${n1}.${n2}`
            "
          >
          </a> -->
          <p
            v-else
            :data-xeslog-params="
              `key=xeslog-macos-www&action=click-macos-pciswinbtn&os=${operatingSystem}&oslev=${n1}.${n2}`
            "
            class="download__content__btn"
            @click="showAlertDialog($event, alert2)"
          ></p>
        </template>
        <template v-else>
          <p class="download__content__alert">{{ alert1 }}</p>
          <a
            v-if="
              operatingSystem == 'Win10' ||
                operatingSystem == 'Win81' ||
                operatingSystem == 'Win8' ||
                operatingSystem == 'WinVista' ||
                operatingSystem == 'Win7'
            "
            :data-xeslog-params="
              `key=xeslog-pcdown-www&action=click-pcbtn-pcdown&os=${operatingSystem}`
            "
            class="download__content__btn"
            href="javascript: () => {return false}"
            @click="handleDownload(false)"
          >
          </a>
          <!-- <a
            v-if="
              operatingSystem == 'Win10' ||
                operatingSystem == 'Win81' ||
                operatingSystem == 'Win8' ||
                operatingSystem == 'WinVista' ||
                operatingSystem == 'Win7'
            "
            :href="
              `https://liveclient.xesimg.com/${winRootPath}/xes_live_win_v${winVersion}.exe?time=${dateTime}&filename=.exe`
            "
            class="download__content__btn"
            :data-xeslog-params="
              `key=xeslog-pcdown-www&action=click-pcbtn-pcdown&os=${operatingSystem}`
            "
          >
          </a> -->
          <p
            v-else
            :data-xeslog-params="
              `key=xeslog-pciswin-www&action=click-pciswin-pciswinbtn&os=${operatingSystem}`
            "
            class="download__content__btn"
            @click="showAlertDialog($event, alert1)"
          ></p>
        </template>
        <p class="download__content__iphone">手机/iPad客户端</p>
        <p class="download__content__tips">
          <a href="https://online.xueersi.com/article/detail/1970" target="_blank"
          >用手机/ipad扫描二维码，查看支持设备 ></a
          >
        </p>
        <img
          v-if="entry === 'slider'"
          alt=""
          class="download__content__image"
          src="./img/wx_code.png"
        />
        <img v-else alt="" class="download__content__image" src="./img/iphoneDown.png" />
      </div>
    </div>
  </div>
</template>

<script>
import detectOS from '@/util/detectOS'
import ConfirmDialog from '@/components/ConfirmDialog'
import builder from '@/modules/dialog-builder'
import { mapState } from 'vuex'
import axios from 'axios'
import titleMixin from '@/util/title'

export default {
  data() {
    return {
      version: null,
      operatingSystem: null,
      str: null,
      ver: null,
      n1: null,
      n2: null,
      // winVersion: '2.9.0',
      // macVersion: '2.8.1',
      entry: null,
      alert1: '请使用Win7及以上系统 推荐硬件：处理器i3以上，内存4G以上',
      alert2: '适用于Mac电脑操作系统版本不低于10.12',
      dateTime: null,
      macRootPath: 'student/mac/2.8.1/165/xes_live_mac_v2.8.1.dmg',
      winRootPath: 'student/win/2.9.0/331/xes_live_win_v2.9.0.exe',
      domainArr: ['https://liveclient.xesimg.com'],
      domainIndex: 0
    }
  },
  mixins: [titleMixin],
  title() {
    return '学而思网校APP下载_学而思网校客户端下载_学而思网校'
  },
  computed: {
    ...mapState({
      downloadData: state => state.downloadData
    })
  },
  async mounted() {
    this.dateTime = new Date().getTime()
    this.entry = this.GetQueryString('entry')
    await axios
      .get(`${window.location.origin}/nodeapi/version`)
      .then(res => {
        console.log('res', res)
        const { data } = res
        // this.winVersion = data.winVersion || this.winVersion
        // this.macVersion = data.macVersion || this.macVersion
        this.macRootPath = data.macRootPath || this.macRootPath
        this.winRootPath = data.winRootPath || this.winRootPath
        this.domainArr = data.domain || this.domainArr
      })
      .catch(error => {
        console.log('error', error)
        this.xesLog(
          'exposure',
          { error: error, key: 'download-error' },
          this.$refs.download
        )
      })
    this.operatingSystem = detectOS()
    // 判断用户是mac系统并且系统版本大于等于10
    if (this.operatingSystem === 'Mac') {
      // 判断macos系统版本
      this.str = navigator.userAgent.toLowerCase()
      this.ver =
        // eslint-disable-next-line no-useless-escape
        this.str.match(/(\d+)\_(\d+)/) || this.str.match(/intel mac os x (\d+)\.(\d+)/)
      this.n1 = Number(this.ver[1])
      this.n2 = Number(this.ver[2])
    }
  },
  methods: {
    handleDownload(isMac) {
      const len = this.domainArr.length
      const domain = this.domainArr[this.domainIndex]
      console.log('domain=======>', len, domain)
      const href = isMac ?
        `${domain}/${this.macRootPath}?time=${this.dateTime}&filename=.dmg` :
        `${domain}/${this.winRootPath}?time=${this.dateTime}&filename=.exe`
      this.domainIndex = (this.domainIndex + 1) % len
      window.location.href = href
    },
    async showAlertDialog(event, message) {
      const confirmDialog = builder(ConfirmDialog, this.$router, this.$store)
      await confirmDialog({ data: message })
    },
    GetQueryString(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
      const r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    xesLog(eventName, params, event) {
      const XESLog = new this.$XESLog({
        ...params
      })
      XESLog.push({ eventname: eventName, target: event }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';

@include b(download) {
  min-width: 1200px;
  min-height: 0 !important;
  position: relative;
  @include e(background) {
    min-width: 1200px;
    min-height: 730px;
    width: 100vw;
    height: 39vw;
    background-image: url('https://activity.xueersi.com/oss/resource/pc-load-bg-97de2.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  @include e(right) {
    position: absolute;
    width: 44.317vw;
    height: 39vw;
    min-height: 730px;
    right: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.9);
  }
  @include e(content) {
    position: absolute;
    top: 50%;
    left: 5vw;
    transform: translateY(-50%);
    text-align: center;
    font-family: Microsoft YaHei;
    @include e(title) {
      font-size: 40px;
      line-height: 40px;
      color: #f13232;
    }
    @include e(client) {
      font-size: 24px;
      line-height: 24px;
      margin-top: 56px;
      color: #000000;
      font-weight: bold;
    }
    @include e(btn) {
      display: inline-block;
      width: 172px;
      height: 40px;
      cursor: pointer;
      background-image: url('./img/btn.png');
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 20px auto;
      margin-bottom: 0;
    }
    @include e(alert) {
      font-size: 14px;
      margin-top: 20px;
      color: #aaaaaa;
      font-family: FZLanTingHei-R-GBK;
    }
    @include e(iphone) {
      color: #000000;
      font-weight: bold;
      font-size: 24px;
      line-height: 24px;
      margin-top: 56px;
    }
    @include e(tips) {
      font-size: 14px;
      font-family: FZLanTingHei-R-GBK;
      margin-top: 20px;
      & > a {
        color: #aaaaaa;
      }
    }
    @include e(image) {
      display: block;
      width: 130px;
      height: 130px;
      margin: 18px auto;
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/DownLoad/index.vue